export const alphaWhiteDiacritic = (value: any) => {
  return /^[a-zA-ZÀ-ž\s]*$/.test(value);
};

export const phone = (value: any) => {
  return /^\+*\d*(\.\d+)?$/.test(value);
};
